(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("treeview", [], factory);
	else if(typeof exports === 'object')
		exports["treeview"] = factory();
	else
		root["treeview"] = factory();
})(this, function() {
return 